import React from 'react';

interface Category {
  id: number;
  name: string;
  title: string;
  parentCategoryId: number | null;
  parentCategoryName?: string;
}

interface CategoryListProps {
  categories: Category[];
  onEditCategory: (category: Category) => void;
  onDeleteCategory: (id: number) => void;
}

const CategoryList: React.FC<CategoryListProps> = ({ categories, onEditCategory, onDeleteCategory }) => {
  const getParentCategoryName = (parentCategoryId: number | undefined) => {
    if (!parentCategoryId) return 'None';
    const parentCategory = categories.find(category => category.id === parentCategoryId);
    return parentCategory ? parentCategory.name : 'None';
  };

  return (
    <section className='container category-list-section mb-5 pb-5'>
      <h2>Category List</h2>
      <div className="list-header">
        <span>Name</span>
        <span>Title</span>
        <span>Parent Category</span>
        <span>Actions</span>
      </div>
 
        {categories.map((category) => (
          <div key={category.id} className='list-row'>
            <div className='grid-item'>{category.name}</div>
            <div className='grid-item'>{category.title}</div>
            <div className='grid-item'>{getParentCategoryName(category.parentCategoryId as number)}</div>
            <div className='category-actions'>
              <button className='btn btn-sm btn-outline-primary me-2' onClick={() => onEditCategory(category)}>  <i className="fas fa-edit"></i>&nbsp;Edit</button>
              <button className='btn btn-sm btn-outline-danger me-2' onClick={() => onDeleteCategory(category.id)}>   <i className="fas fa-trash-alt"></i>&nbsp;Delete</button>
            </div>
          </div>
        ))}
     
    </section>
  );
};

export default CategoryList;